// src/pages/payment/PaymentSuccessPage.js
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Logo from '../../components/common/Logo';
import Sidebar from '../../components/patient/PatientSidebar';
import PaymentService from '../../services/payment.service';

const PaymentSuccessPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    const sessionId = new URLSearchParams(location.search).get('session_id');
    const paymentStatus = new URLSearchParams(location.search).get('payment_status');
    
    // Pulisci il sessionStorage del pagamento pending (se esiste)
    sessionStorage.removeItem('pendingPayment');
    
    // Se c'è un payment_status=success, è un pagamento tramite coupon
    if (paymentStatus === 'success') {
      setLoading(false);
    }
    // Se c'è un session_id, è un pagamento Stripe
    else if (sessionId) {
      // Opzionale: chiamata al backend per confermare il pagamento
      PaymentService.confirmSession(sessionId)
        .then(() => {
          setLoading(false);
        })
        .catch(err => {
          console.error('Errore durante la conferma del pagamento:', err);
          setError('Si è verificato un problema durante la verifica del pagamento.');
          setLoading(false);
        });
    } 
    // Se non c'è né session_id né payment_status, c'è un errore
    else {
      setError('Informazioni sul pagamento mancanti.');
      setLoading(false);
    }
  }, [location]);
  
  const handleContinue = () => {
    navigate('/patient/appointments');
  };

  return (
    <div className="flex min-h-screen">
      <div className="w-64 bg-white shadow-md">
        <div className="p-4">
          <Logo />
        </div>
        <Sidebar />
      </div>
      
      <div className="flex-1 p-8 bg-[#FAF4EB] flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-md text-center max-w-md w-full">
          {loading ? (
            <div className="py-8">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-600 mx-auto mb-4"></div>
              <p className="text-gray-600">Conferma del pagamento in corso...</p>
            </div>
          ) : error ? (
            <div>
              <div className="w-20 h-20 bg-red-100 rounded-full mx-auto mb-6 flex items-center justify-center">
                <svg className="w-10 h-10 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </div>
              <h2 className="text-xl font-bold text-red-700 mb-4">Si è verificato un errore</h2>
              <p className="text-gray-600 mb-6">{error}</p>
              <button
                onClick={() => navigate('/patient/dashboard')}
                className="w-full bg-purple-600 text-white py-2 px-4 rounded hover:bg-purple-700"
              >
                Torna alla Dashboard
              </button>
            </div>
          ) : (
            <div>
              <div className="w-20 h-20 bg-green-100 rounded-full mx-auto mb-6 flex items-center justify-center">
                <svg className="w-10 h-10 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-green-700 mb-4">Pagamento completato con successo!</h2>
              <p className="text-gray-600 mb-6">
                Il tuo appuntamento è stato confermato. Riceverai a breve una email con tutti i dettagli.
              </p>
              <button
                onClick={handleContinue}
                className="w-full bg-purple-600 text-white py-2 px-4 rounded hover:bg-purple-700"
              >
                Visualizza i tuoi appuntamenti
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;